export default "__VITE_ASSET__652eb1a4__"